import { userGroupActions } from '../user-group-actions'

export const vendorMenu: any[] = [
  {
    title: 'Dashboard',
    desc: 'Vendor Dashboard',
    root: true,
    icon: 'flaticon-line-graph',
    page: '/vendor/dashboard',
    // badge: {type: 'm-badge--danger', value: '2'},
    translate: 'MENU.DASHBOARD',
  },
  {
    title: 'Dealers',
    desc: 'Dealers',
    root: true,
    page: '/vendor/dealers',
    icon: 'flaticon-users',
    actionId: userGroupActions.vendor.DEALERS.INDEX,
  },
  {
    title: 'Estimates',
    desc: 'Estimates',
    root: true,
    icon: 'flaticon-list-1',
    page: '/vendor/proposals',
    actionId: userGroupActions.vendor.PROPOSALS.INDEX,
  },
  {
    title: 'Orders',
    desc: 'Orders',
    root: true,
    icon: 'flaticon-truck',
    page: '/vendor/orders',
    actionId: userGroupActions.vendor.ORDERS.INDEX,
  },
  // {
  // 	title: 'Payments',
  // 	desc: 'Payments',
  // 	root: true,
  // 	icon: 'flaticon-coins',
  // 	page: '/vendor/payments'
  // },
  // {
  // 	title: "RMA",
  // 	desc: "RMA",
  // 	root: true,
  // 	icon: "flaticon-open-box",
  // 	page: "/vendor/rmas",
  // 	actionId: userGroupActions.vendor.RMA.INDEX
  // },
  {
    title: 'Catalog',
    desc: 'Catalog',
    root: true,
    icon: 'flaticon-map',
    bullet: 'dot',
    actionId: userGroupActions.vendor.CATALOG.INDEX,
    submenu: [
      {
        title: 'Construction types',
        page: '/vendor/construction-types',
      },
      {
        title: 'Materials',
        page: '/vendor/materials',
      },
      {
        title: 'Finishes',
        page: '/vendor/finishes',
      },
      {
        title: 'Styles',
        page: '/vendor/styles',
        // actionId: userGroupActions.vendor.STYLES.INDEX
      },
      {
        title: 'Lip options',
        page: '/vendor/lip-options',
      },
      {
        title: 'Bead options',
        page: '/vendor/bead-options',
      },
      {
        title: 'Panel options',
        page: '/vendor/panel-options',
      },
      {
        title: 'Drawer options',
        page: '/vendor/drawer-options',
      },
      {
        title: 'Parts',
        page: '/vendor/parts',
        actionId: userGroupActions.vendor.PARTS.INDEX,
      },
      {
        title: 'Modifications',
        page: '/vendor/modifications',
      },
      {
        title: 'Finish options',
        page: '/vendor/finish-options',
      },
      {
        title: 'Footage items',
        page: '/vendor/footage-items',
      },
      {
        title: 'Design charges',
        page: '/vendor/design-charges',
      },
      // {
      // 	title: 'Files & History',
      // 	page: '/vendor/catalog-history'
      // },
    ],
  },
  // {
  // 	title: "Parts",
  // 	desc: "Parts",
  // 	root: true,
  // 	icon: "flaticon-tool",
  // 	page: "/vendor/parts",
  // 	actionId: userGroupActions.vendor.PARTS.INDEX
  // },
  // {
  // 	title: "Inventory",
  // 	desc: "Inventory",
  // 	root: true,
  // 	icon: "flaticon-interface-6",
  // 	bullet: "dot",
  // 	submenu: [
  // 		{
  // 			title: "Items",
  // 			page: "/vendor/inventory/items",
  // 			actionId: userGroupActions.vendor.INVENTORY.ITEMS.INDEX
  // 		},
  // 		{
  // 			title: "Purchase orders",
  // 			page: "/vendor/inventory/purchase-orders",
  // 			actionId:
  // 				userGroupActions.vendor.INVENTORY.PURCHASE_ORDERS.INDEX
  // 		},
  // 		{
  // 			title: "Barcodes",
  // 			page: "/vendor/inventory/barcodes",
  // 			actionId: userGroupActions.vendor.INVENTORY.BARCODES.INDEX
  // 		},
  // 		{
  // 			title: 'Activity',
  // 			page: '/vendor/inventory/activity',
  // 			// TODO: Add action id
  // 		}
  // 	]
  // },
  {
    title: 'Resources',
    desc: 'Resources',
    root: true,
    icon: 'flaticon-folder-1',
    page: '/vendor/resources',
    actionId: userGroupActions.vendor.RESOURCES.INDEX,
  },
  // {
  // 	title: "Feedback",
  // 	desc: "Feedback",
  // 	root: true,
  // 	icon: "flaticon-comment",
  // 	page: "/vendor/feedback",
  // 	actionId: userGroupActions.vendor.FEEDBACK.INDEX
  // },
  {
    title: 'Announcements',
    desc: 'Announcements',
    root: true,
    icon: 'flaticon-information',
    page: '/vendor/announcements',
    actionId: userGroupActions.vendor.ANNOUNCEMENTS.INDEX,
  },
  // {
  // 	title: "Accounting",
  // 	desc: "Accounting",
  // 	root: true,
  // 	icon: "flaticon-customer",
  // 	bullet: "dot",
  // 	submenu: [
  // 		{
  // 			title: "Accounts",
  // 			page: "/vendor/accounting/accounts",
  // 			actionId: userGroupActions.vendor.ACCOUNTING.ACCOUNTS.INDEX
  // 		},
  // 		{
  // 			title: "Payments",
  // 			page: "/vendor/accounting/payments",
  // 		},
  // 	]
  // },
  // {
  // 	title: "Expenses",
  // 	desc: "Expenses",
  // 	root: true,
  // 	icon: "flaticon-coins",
  // 	page: "/vendor/expenses",
  // 	actionId: userGroupActions.vendor.EXPENSES.INDEX
  // },
  // {
  // 	title: 'Incomes',
  // 	desc: 'Incomes',
  // 	root: true,
  // 	icon: 'flaticon-graphic',
  // 	page: '/vendor/incomes'
  // },
  {
    title: 'Reports',
    desc: 'Reports',
    root: true,
    icon: 'flaticon-diagram',
    bullet: 'dot',
    submenu: [
      {
        title: 'Sales rep',
        page: '/vendor/reports/sales-representatives',
        actionId: userGroupActions.vendor.REPORTS.SALES_REP.INDEX,
      },
      {
        title: 'Sales orders',
        page: '/vendor/reports/sales-orders',
        actionId: userGroupActions.vendor.REPORTS.SALES_ORDERS.INDEX,
      },
      // {
      // 	title: "Account aging",
      // 	page: "/vendor/reports/accounts-receivables"
      // },
      // {
      // 	title: "Inventory aging",
      // 	page: "/vendor/reports/aging",
      // 	actionId: userGroupActions.vendor.REPORTS.AGING.INDEX
      // },
      // Report is merged into Inventory report
      // {
      // 	title: "Sales inventory",
      // 	page: "/vendor/reports/sales-inventory",
      // 	actionId: userGroupActions.vendor.REPORTS.SALES_INVENTORY.INDEX
      // },
      // {
      // 	title: "Inventory",
      // 	page: "/vendor/reports/inventory",
      // 	actionId: userGroupActions.vendor.REPORTS.INVENTORY.INDEX
      // },
      // {
      // 	title: "Profit",
      // 	page: "/vendor/reports/profit",
      // 	actionId: userGroupActions.vendor.REPORTS.PROFIT.INDEX
      // },
      // {
      // 	title: "Balance",
      // 	page: "/vendor/reports/balance",
      // 	actionId: userGroupActions.vendor.REPORTS.BALANCE.INDEX
      // }
    ],
  },
  // {
  // 	title: "Support",
  // 	root: true,
  // 	icon: "flaticon-support",
  // 	page: "/vendor/support"
  // },
  {
    title: 'Settings',
    desc: 'Settings',
    root: true,
    icon: 'flaticon-settings',
    bullet: 'dot',
    submenu: [
      {
        title: 'General',
        page: '/vendor/settings/general',
        actionId: userGroupActions.vendor.SETTINGS.GENERAL.INDEX,
      },
      {
        title: 'Users',
        page: '/vendor/settings/users',
        actionId: userGroupActions.vendor.SETTINGS.USERS.INDEX,
      },
      {
        title: 'Dealer Users',
        page: '/vendor/settings/dealer-users',
      },
      {
        title: 'Sales Reps',
        page: '/vendor/settings/sales-reps',
        actionId: userGroupActions.vendor.SETTINGS.SALES_REPS.INDEX,
      },
      {
        title: 'Holidays',
        page: '/vendor/settings/holidays',
        actionId: userGroupActions.vendor.SETTINGS.HOLIDAYS.INDEX,
      },
      // {
      // 	title: "Inventory",
      // 	page: "/vendor/inventory/settings",
      // 	actionId: userGroupActions.vendor.INVENTORY.SETTINGS.INDEX
      // },
      // {
      // 	title: "Shipping",
      // 	page: "/vendor/settings/shipping",
      // 	actionId: userGroupActions.vendor.SETTINGS.SHIPPING.INDEX
      // },

      // {
      // 	title: "Assembly",
      // 	page: "/vendor/settings/assembly",
      // 	actionId: userGroupActions.vendor.SETTINGS.ASSEMBLY.INDEX
      // },
      // {
      // 	title: "Payments",
      // 	page: "/vendor/settings/payments",
      // 	actionId: userGroupActions.vendor.SETTINGS.PAYMENTS.INDEX
      // },
      {
        title: 'Taxes',
        page: '/vendor/settings/taxes',
        actionId: userGroupActions.vendor.SETTINGS.TAXES.INDEX,
      },
      // {
      // 	title: "Expenses",
      // 	page: "/vendor/settings/expenses",
      // 	actionId: userGroupActions.vendor.SETTINGS.EXPENSES.INDEX
      // },
      // {
      // 	title: 'Incomes',
      // 	page: '/vendor/settings/incomes'
      // },
      // {
      // 	title: "Permissions",
      // 	page: "/vendor/settings/permissions",
      // 	actionId: userGroupActions.vendor.SETTINGS.PERMISSIONS.INDEX
      // },
      {
        title: 'Audit logs',
        page: '/vendor/settings/audit-logs',
        actionId: userGroupActions.vendor.SETTINGS.AUDIT_LOGS.INDEX,
      },
    ],
  },
]
